import React from 'react';
import { Select, Form } from 'antd';
import { Store, Tags, Settings2 } from 'lucide-react';
import { TraditionalStores, SectionCard } from '../../../common';

function CreateListForm({ channel, setChannel, clients, fetchStoreType, storeType }) {
    const traditionalType = TraditionalStores.map((store) => ({
        label: store.label,
        value: store.value
    }));

    const modernClients = clients
        ?.filter((client) => client.channel === 'moderno')
        ?.map((client) => ({
            label: client.name,
            value: client._id
        }));

    return (
        <SectionCard
            className="mb-4"
            icon={<Settings2 />}
            iconTone="brand"
            title="Configurar Lista de Precio"
            description="Selecciona el canal y la segmentación para crear una nueva lista de precios">
            <Form layout="vertical" requiredMark>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <Form.Item label="Canal de la Lista de Precio" required className="mb-0">
                        <Select
                            value={channel}
                            onChange={(e) => setChannel(e)}
                            placeholder="Selecciona el canal"
                            options={[
                                { label: 'Moderno', value: 'moderno' },
                                { label: 'Tradicional', value: 'tradicional' }
                            ]}
                            suffixIcon={<Store className="text-surface-400" />}
                        />
                    </Form.Item>

                    <Form.Item label="Segmentación de la Lista" required className="mb-0">
                        <Select
                            value={storeType?.value}
                            onChange={async (e) => {
                                await fetchStoreType(e);
                            }}
                            placeholder="Selecciona la segmentación"
                            options={channel === 'moderno' ? modernClients : traditionalType}
                            suffixIcon={<Tags className="text-surface-400" />}
                        />
                    </Form.Item>
                </div>
            </Form>
        </SectionCard>
    );
}

export default CreateListForm;
